(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('UserCategoryController', UserCategoryController);

    /* @ngInject */
    function UserCategoryController(userCategoryService, $uibModal, logger) {
        var vm = this;        
                
        var modalOptions = userCategoryService.getModalOptions();

        vm.tableConfig = configureTableActions();

        vm.userCategories = [];
        vm.getUserCategories = userCategoryService.getUserCategories;
        vm.addUserCategory = addUserCategory;              

        function editUserCategory(userCategory) {            
            modalOptions.controller = 'CategoryEditController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    userCategory: function () {
                        return angular.copy(userCategory);
                    }
                }
            }, modalOptions));

            modalInstance.result.then(function (updatedUserCategory) {
                angular.extend(userCategory, updatedUserCategory);
            }, function () {
                logger.info('Modal dismissed at: ' + new Date());
            });
        }

        function addUserCategory() {           
            modalOptions.controller = 'CategoryAddController';
            var modalInstance = $uibModal.open(modalOptions);

            modalInstance.result.then(function (newUserCategory) {
                vm.isLoading = false;
                vm.userCategories.unshift(newUserCategory);
            }, function () {
                logger.info('Modal dismissed at: ' + new Date());
            });
        }

        function configureTableActions() {
            var tableConfig = userCategoryService.getTableConfig();
            tableConfig.actions = [
                {
                    name: '"Edit"',
                    action: editUserCategory,
                    icon: '"fa-edit"',
                    permission: 'SSO:SysAdmin'

                }];
            return tableConfig;
        }
    }
})();
